import React, { type PropsWithChildren, useEffect, useState } from 'react';
import { type Locale, setDefaultOptions } from 'date-fns';
import { getUserLocale } from 'get-user-locale';
import { LocaleContext } from 'context/index';
import useUserContext from 'context/UserContext/hook';
import { loadZodLocale } from 'utils/modules/intl';

async function resolveLocale(locale_ = getUserLocale()): Promise<Locale> {
   let locale: Locale;

   try {
      locale = (await import(`date-fns/locale/${locale_}/index.js`)).default;
      return locale;
   } catch {
      try {
         locale = (await import(`date-fns/locale/${locale_.substring(0, 2)}/index.js`)).default;
         return locale;
      } catch {
         locale = (await import(`date-fns/locale/en-US/index.js`)).default;
         return locale;
      }
   }
}

const LocaleContextComponent: React.FC<PropsWithChildren> = ({ children }) => {
   const {
      state: { locale: userLocale },
   } = useUserContext();

   const [locale, setLocale] = useState<Locale | undefined>(undefined);

   useEffect(() => {
      resolveLocale(userLocale)
         .then((locale_) => {
            setDefaultOptions({ locale: locale_ });
            setLocale(locale_);
            return locale_;
         })
         .catch((err) => {
            throw new Error(err);
         });
   }, [userLocale]);

   useEffect(() => {
      if (locale?.code) {
         loadZodLocale(locale.code.split('-')[0]);
      }
   }, [locale?.code]);

   return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
};

export default LocaleContextComponent;
